import { ChangeDetectionStrategy, ChangeDetectorRef, Component, HostListener, NgZone, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { LogEntry, LogLevelEnum, LogService } from '@app/common';
import { AuthService, UrlService } from '@app/shared/services';
import {
  NgcCookieConsentService,
  NgcNoCookieLawEvent,
  NgcStatusChangeEvent,
  NgcInitializationErrorEvent,
  NgcInitializingEvent,
} from 'ngx-cookieconsent';
import { Subject, Subscription } from 'rxjs';
import { debounceTime, filter } from 'rxjs/operators';
import { LoginStoreEffects } from './root-store/login-store/effects';
import { SharedLogoutComponent } from './shared/component/shared-logout/shared-logout.component';
import { environment } from '@env/environment';
// import { Auth, Hub } from 'aws-amplify';
import { UserTypeEnum } from './enum/UserTypeEnum';
import { ToastrService } from 'ngx-toastr';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MxTaskbarService } from './shared/services/mx-taskbar/mx-taskbar.service';
import { MatSidenav } from '@angular/material/sidenav';
import { HomeSubjectService } from './modules/home-page/container/home-subject.service';
import { NetworkSetupNavService } from './shared/services/network-setup-nav/network-setup-nav.service';
import { fetchUserAttributes } from '@aws-amplify/auth';
import { Hub } from '@aws-amplify/core';
import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';
@AutoUnsubscribe()
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-root',
  styleUrls: ['./app.component.scss'],
  templateUrl: './app.component.html',
})
export class AppComponent implements OnInit, OnDestroy {
  @ViewChild('homePageDrawer') public sidenav: MatSidenav;
  recaptchaSiteKey: string;
  previousUrl: string = null;
  currentUrl: string = null;
  timedOut = false;
  lastPing?: Date = null;

  openSideBar = false;
  accountSetupOpened = false;
  introToKinnectOpened = false;
  onboardingResponsibilityOpened = false;
  openDiscoveryCategoryConfig = false;
  networkSetupOpened = false;
  securityPrivacySetupOpened = false;
  accountType: string = 'showInstruction';
  discoveryCategoryConfigType: any;
  switchFromUser = false;

  counter: number;
  private logoutDialogRef: any;
  isUserLoggedIn = false;
  private idleWorker: Worker | undefined;
  private activitySubject = new Subject<void>();
  private hubListenerCleanup: (() => void) | undefined; // Hub.listen cleanup function

  //keep refs to subscriptions to be able to unsubscribe later
  private popupOpenSubscription: Subscription;
  private popupCloseSubscription: Subscription;
  private initializingSubscription: Subscription;
  private initializedSubscription: Subscription;
  private statusChangeSubscription: Subscription;
  private revokeChoiceSubscription: Subscription;
  private noCookieLawSubscription: Subscription;
  private initializationErrorSubscription: Subscription;
  subscription: Subscription = new Subscription();
  displayRecaptchaBadge = false;
  userId: string;

  constructor(
    private router: Router,
    private urlService: UrlService,
    private LogService: LogService,
    private dialog: MatDialog,
    private ccService: NgcCookieConsentService,
    private loginService: LoginStoreEffects,
    private mxTaskbarService: MxTaskbarService,
    private toastr: ToastrService,
    private modalService: NgbModal,
    private ngZone: NgZone,
    private authService: AuthService,
    private cd: ChangeDetectorRef,
    private route: ActivatedRoute,
    private homeSubjectService: HomeSubjectService,
    private networkSetupNavService: NetworkSetupNavService
  ) {
    this.recaptchaSiteKey = environment.recaptcha_siteKey;
    // this.loadRecaptchaScript();

    this.LogService.log(new LogEntry('AppComponent constructor', LogLevelEnum.INFO));
    this.subscription.add(
      this.activitySubject.pipe(debounceTime(500)).subscribe(() => {
        this.resetIdleState();
      })
    );
  }

  ngOnInit(): void {
    this.subscription.add(
      this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
        this.previousUrl = this.currentUrl;
        this.currentUrl = event.url;
        this.urlService.setPreviousUrl(this.previousUrl);
      })
    );

    this.subscription.add(
      this.loginService.loginObject.subscribe(async (state) => {
        const loginStateObject = state.data;
        const authUser = this.authService.user;
        if (loginStateObject?.id) {
          this.userId = loginStateObject?.id;
        }
        if (loginStateObject?.switch_from_user_id && loginStateObject?.id !== authUser['id']) {
          this.switchFromUser = loginStateObject?.switchFromUser;
        } else {
          this.switchFromUser = null;
        }
        this.cd.detectChanges();
      })
    );

    this.checkIfUserAuthenticated();
    this.subscription.add(
      this.router.events.subscribe((event) => {
        if (event instanceof NavigationEnd && this.isUserLoggedIn) {
          this.resetIdleState();
          // this.checkIfUserAuthenticated();
        }
        this.resetFalseAll();
      })
    );

    // Store Hub.listen cleanup function for proper cleanup in ngOnDestroy
    this.hubListenerCleanup = Hub.listen('auth', (data) => {
      const { event } = data.payload;
      console.warn('Idle:Hub.listen:auth', event);
      if (event === 'signedIn') {
        this.isUserLoggedIn = true;
        this.startIdleMonitor();
      } else if (event === 'signedOut') {
        this.isUserLoggedIn = false;
        this.terminateIdleWorker();
      }
    });

    // // subscribe to cookieconsent observables to react to main events
    // this.popupOpenSubscription = this.ccService.popupOpen$.subscribe(() => {
    //   // you can use this.ccService.getConfig() to do stuff...
    // });

    // this.popupCloseSubscription = this.ccService.popupClose$.subscribe(() => {});

    // this.initializeSubscription = this.ccService.initialized$.subscribe((event: NgcInitializingEvent) => {
    //   // you can use this.ccService.getConfig() to do stuff..
    // });

    // this.statusChangeSubscription = this.ccService.statusChange$.subscribe((event: NgcStatusChangeEvent) => {
    //   // you can use this.ccService.getConfig() to do stuff...
    // });

    // this.revokeChoiceSubscription = this.ccService.revokeChoice$.subscribe(() => {
    //   // you can use this.ccService.getConfig() to do stuff...
    // });

    // this.noCookieLawSubscription = this.ccService.noCookieLaw$.subscribe((event: NgcNoCookieLawEvent) => {
    //   // you can use this.ccService.getConfig() to do stuff...
    // });

    // New
    // eslint-disable-next-line eslint-rules/no-unmanaged-subscriptions
    this.popupOpenSubscription = this.ccService.popupOpen$.subscribe(() => {
      // you can use this.ccService.getConfig() to do stuff...
    });
    // eslint-disable-next-line eslint-rules/no-unmanaged-subscriptions
    this.popupCloseSubscription = this.ccService.popupClose$.subscribe(() => {
      // you can use this.ccService.getConfig() to do stuff...
    });
    // eslint-disable-next-line eslint-rules/no-unmanaged-subscriptions
    this.initializingSubscription = this.ccService.initializing$.subscribe((event: NgcInitializingEvent) => {
      // the cookieconsent is initilializing... Not yet safe to call methods like `NgcCookieConsentService.hasAnswered()`
      console.warn(`initializing: ${JSON.stringify(event)}`);
    });
    // eslint-disable-next-line eslint-rules/no-unmanaged-subscriptions
    this.initializedSubscription = this.ccService.initialized$.subscribe(() => {
      // the cookieconsent has been successfully initialized.
      // It's now safe to use methods on NgcCookieConsentService that require it, like `hasAnswered()` for eg...
      console.warn(`initialized: Cookie consent has been successfully initialized`);
    });
    // eslint-disable-next-line eslint-rules/no-unmanaged-subscriptions
    this.initializationErrorSubscription = this.ccService.initializationError$.subscribe((event: NgcInitializationErrorEvent) => {
      // the cookieconsent has failed to initialize...
      console.warn(`initializationError: ${JSON.stringify(event.error?.message)}`);
    });
    // eslint-disable-next-line eslint-rules/no-unmanaged-subscriptions
    this.statusChangeSubscription = this.ccService.statusChange$.subscribe((event: NgcStatusChangeEvent) => {
      // you can use this.ccService.getConfig() to do stuff...
    });
    // eslint-disable-next-line eslint-rules/no-unmanaged-subscriptions
    this.revokeChoiceSubscription = this.ccService.revokeChoice$.subscribe(() => {
      // you can use this.ccService.getConfig() to do stuff...
    });
    // eslint-disable-next-line eslint-rules/no-unmanaged-subscriptions
    this.noCookieLawSubscription = this.ccService.noCookieLaw$.subscribe((event: NgcNoCookieLawEvent) => {
      // you can use this.ccService.getConfig() to do stuff...
    });
    this.subscription.add(
      this.ccService.statusChange$.subscribe((event: any) => {
        console.warn('**', event);
        if (event.status === 'dismiss') {
          this.authService.setCookie('cookieconsent_status', 'dismiss', 365);
        } else if (event.status === 'deny') {
          this.authService.clearCookie('userConsent');
        }
      })
    );

    this.subscription.add(
      this.route.paramMap.subscribe(() => {
        const state = window.history.state;
        const nextStep = state?.setupStep;

        const stepSetupHandlers = {
          intro_to_kinnect_setup_status: () => (this.introToKinnectOpened = true),
          account_setup_status: () => (this.accountSetupOpened = true),
          security_and_privacy_setup_status: () => (this.securityPrivacySetupOpened = true),
          network_setup_status: () => (this.networkSetupOpened = true),
          onboarding_responsibility_complete_status: () => (this.onboardingResponsibilityOpened = true),
        };

        if (nextStep && stepSetupHandlers[nextStep]) {
          setTimeout(() => {
            stepSetupHandlers[nextStep]();
            this.cd.detectChanges();
          }, 10000);
        }
      })
    );

    this.subscription.add(
      this.homeSubjectService.fetchSetupData.subscribe((data) => {
        if (data) {
          this.openSetupItemCardEvent(data);
        }
      })
    );

    this.subscription.add(
      this.homeSubjectService.closeSetupItemCard.subscribe((data) => {
        if (data) {
          this.closeIntroSetupSideBarEventEmitter();
        }
      })
    );

    this.subscription.add(
      this.homeSubjectService.fetchDiscoverySetupData.subscribe((data) => {
        this.openDiscoverySetupItemCardEvent(data);
      })
    );
    this.subscription.add(
      this.networkSetupNavService.isOpened.subscribe((data) => {
        if (!data) this.closeDrawerEventHandler();
      })
    );
  }

  @HostListener('document:mousemove')
  @HostListener('document:keydown')
  @HostListener('document:mousedown')
  @HostListener('document:touchstart')
  @HostListener('document:scroll')
  @HostListener('document:wheel')
  @HostListener('document:click')
  monitorUserActivity() {
    this.activitySubject.next();
  }

  resetIdleState() {
    if (this.isUserLoggedIn && this.idleWorker && !this.logoutDialogRef) {
      console.warn('Idle:resetIdleState: User activity detected. Resetting timer...');
      this.idleWorker.postMessage('reset-idle');
    }
  }

  openBalanceSheetSideBar() {
    this.openSideBar =
      this.introToKinnectOpened ||
      this.accountSetupOpened ||
      this.securityPrivacySetupOpened ||
      this.networkSetupOpened ||
      this.onboardingResponsibilityOpened ||
      this.openDiscoveryCategoryConfig;
  }
  async checkIfUserAuthenticated(): Promise<void> {
    try {
      await fetchUserAttributes();
      console.warn('Idle:checkIfUserAuthenticated: User is authenticated:');
      this.isUserLoggedIn = true;
      this.startIdleMonitor();
    } catch (error) {
      console.warn('Idle:checkIfUserAuthenticated:error:xxxxxxxxxxxxxxxxxxxxxx', error);
      this.isUserLoggedIn = false;
      this.terminateIdleWorker();
    }
  }

  // Initialize the Web Worker for idle detection
  startIdleMonitor(): void {
    if (!this.idleWorker && typeof Worker !== 'undefined') {
      this.idleWorker = new Worker(new URL('./shared/workers/idle-user-detection.worker', import.meta.url));
      this.idleWorker.onmessage = ({ data }) => {
        console.warn('Idle:startIdleMonitor: onmessage', data);
        if (data.startsWith('start-countdown')) {
          this.ngZone.run(() => {
            // Trigger actions when user is idle
            this.counter = parseInt(data.split(':')[1], 10);
            console.warn('Idle:startIdleMonitor:ngZone', this.counter);
            if (!this.logoutDialogRef && this.counter > 0) {
              this.logoutDialogRef = this.dialog.open(SharedLogoutComponent, {
                disableClose: true,
                data: { counter: this.counter },
              });
              this.subscription.add(
                this.logoutDialogRef.afterClosed().subscribe((confirmation) => {
                  if (confirmation) {
                    this.logoutDialogRef = null;
                    this.counter = null;
                    this.cd.detectChanges();
                    this.resetIdleState();
                  } else {
                    this.logoutDialogRef = null;
                    if (this.isUserLoggedIn) {
                      this.onLogout();
                    }
                    this.terminateIdleWorker();
                    // location.reload();
                  }
                })
              );
            }
            if (this.logoutDialogRef) {
              this.logoutDialogRef.componentInstance.updateCounter(this.counter);
            }
          });
        } else if (data === 'idleTimeout') {
          this.onLogout();
        }
      };
      if (this.isUserLoggedIn) {
        this.idleWorker.postMessage('start-idle');
      } else {
        this.terminateIdleWorker();
      }
    } else {
      console.warn('Idle worker already initialized', this.idleWorker);
    }
  }

  // Terminate the worker to stop idle detection
  private terminateIdleWorker(): void {
    if (this.idleWorker) {
      this.idleWorker.postMessage('stop-idle');
      this.idleWorker.terminate();
      this.idleWorker = undefined;
      this.cd.detectChanges();
      console.warn('Idle:terminateIdleWorker: Idle worker terminated');
    }
  }

  onLogout() {
    const user = this.authService.user;
    const logoutURL = user.user_type === UserTypeEnum.Professional ? '/' : '/';
    this.subscription.add(
      this.authService.logoutWithGuardianCheck().subscribe(
        () => {
          this.dialog.closeAll();
          this.modalService.dismissAll('user logged out');
          this.mxTaskbarService.clearMinimizedDialogs();
          this.cd.detectChanges();
          // this.store$.dispatch(new loginStoreActions.LogoutSuccessAction());
          this.router.navigate([logoutURL]);
        },
        (error: any) => {
          this.toastr.error(error.error.message);
          return false;
        }
      )
    );
  }

  ngOnDestroy() {
    this.terminateIdleWorker();
    if (this.logoutDialogRef) {
      this.logoutDialogRef.close();
      this.logoutDialogRef = null;
    }

    // Clean up Hub.listen to prevent memory leaks
    if (this.hubListenerCleanup) {
      this.hubListenerCleanup();
    }

    // unsubscribe to cookieconsent observables to prevent memory leaks
    this.popupOpenSubscription?.unsubscribe();
    this.popupCloseSubscription?.unsubscribe();
    this.initializingSubscription?.unsubscribe();
    this.initializedSubscription?.unsubscribe();
    this.statusChangeSubscription?.unsubscribe();
    this.revokeChoiceSubscription?.unsubscribe();
    this.noCookieLawSubscription?.unsubscribe();
    this.initializationErrorSubscription?.unsubscribe();
    this.subscription?.unsubscribe();

    // Complete the activity subject
    this.activitySubject.complete();
  }

  closeDrawerEventHandler() {
    this.homeSubjectService.handleFetchSetupData(null);
    this.resetFalseAll();
    this.sidenav.close();
  }

  closeDiscoveryCategoryConfigEventEmitter() {
    this.openDiscoveryCategoryConfig = false;
    this.openBalanceSheetSideBar();
    this.homeSubjectService.handleFetchDiscoveryClosed(true);
  }

  openSetupItemCardEvent(event) {
    if (!event) {
      return;
    }
    if (event === 'intro_to_kinnect') {
      this.introToKinnectOpened = true;
      this.openBalanceSheetSideBar();
    } else if (event === 'account_setup') {
      this.accountSetupOpened = true;
      this.openBalanceSheetSideBar();
    } else if (event === 'security_and_privacy') {
      this.securityPrivacySetupOpened = true;
      this.openBalanceSheetSideBar();
    } else if (event === 'network_setup') {
      this.networkSetupOpened = true;
      this.openBalanceSheetSideBar();
    } else if (event === 'onboarding_responsibility_complete') {
      this.onboardingResponsibilityOpened = true;
      this.openBalanceSheetSideBar();
    } else if (event === 'closed') {
      this.resetFalseAll();
      this.openBalanceSheetSideBar();
    }
  }

  closeIntroSetupSideBarEventEmitter() {
    this.resetFalseAll();
    this.sidenav.close();
  }

  openDiscoverySetupItemCardEvent(event) {
    if (!event) {
      return;
    }
    this.openDiscoveryCategoryConfig = true;
    this.discoveryCategoryConfigType = event;
    this.openBalanceSheetSideBar();
  }

  resetFalseAll() {
    this.accountSetupOpened = false;
    this.networkSetupOpened = false;
    this.securityPrivacySetupOpened = false;
    this.introToKinnectOpened = false;
    this.onboardingResponsibilityOpened = false;
    this.openDiscoveryCategoryConfig = false;
    this.openBalanceSheetSideBar();
    this.homeSubjectService.handleFetchSetupData(null);
    // this.cd.detectChanges();
  }

  private loadRecaptchaScript(): void {
    const script = document.createElement('script');
    script.src = `https://www.google.com/recaptcha/enterprise.js?render=${this.recaptchaSiteKey}`;
    document.head.appendChild(script);
  }

  handleMainSideNav(val: any) {
    this.homeSubjectService.handleFetchMainSideNav(val);
  }
}
